module.exports = __webpack_public_path__ + "img/BE0413564943.cacf8348.png";